<template>
  <BasicTitle v-langTips bold :helpMessage="helpMessage" :data-lang-key="title">
    {{ t(title!) }}
  </BasicTitle>
</template>
<script lang="ts" setup>
  import type { PropType } from 'vue';
  import { BasicTitle } from '@mts/components/Basic';
  import { t } from '@mts/hooks/web/useI18n';

  defineOptions({ name: 'BasicModalHeader' });

  defineProps({
    helpMessage: {
      type: [String, Array] as PropType<string | string[]>,
    },
    title: { type: [String] as PropType<string> },
  });
</script>
